function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M46.6667 30H3.33333V5H46.6667V30ZM4.99999 28.3333H45V6.66667H4.99999V28.3333Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M12.5 32.5H45V34.1667H12.5V32.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M10 31.6666H11.6667V35H10V31.6666Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M5 32.5H9.16667V34.1667H5V32.5Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M19.1667 25.5151V9.48486L35.1965 17.5L19.1667 25.5151ZM20.8333 12.1818V22.8182L31.4701 17.5L20.8333 12.1818Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M47.5 1.66663H2.5C1.11938 1.66663 0 2.78601 0 4.16663V35.8333C0 37.2139 1.11938 38.3333 2.5 38.3333H17.5V43.3333H9.16667V48.3333H40.8333V43.3333H32.5V38.3333H47.5C48.8806 38.3333 50 37.2139 50 35.8333V4.16663C50 2.78601 48.8806 1.66663 47.5 1.66663ZM39.1667 45V46.6666H10.8333V45H39.1667ZM30.8333 43.3333H19.1667V38.3333H30.8333V43.3333ZM48.3333 35.8333C48.3333 36.2935 47.9602 36.6666 47.5 36.6666H2.5C2.03979 36.6666 1.66667 36.2935 1.66667 35.8333V4.16663C1.66667 3.70642 2.03979 3.33329 2.5 3.33329H47.5C47.9602 3.33329 48.3333 3.70642 48.3333 4.16663V35.8333Z",
  fill: "white"
});

var SvgVideoDesktoo = function SvgVideoDesktoo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoDesktoo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-desktoo.55de66d5.svg";
export { ForwardRef as ReactComponent };